<div class="fd-modal__container">
  <fa-icon icon="exclamation-triangle" class="fd-modal__warning-icon" size="3x"></fa-icon>
  <div mat-dialog-content class="fd-modal__title">
    <p>{{ data.title }}</p>
  </div>
  <div mat-dialog-content class="fd-modal__content" *ngIf="!data.html">
    <p>{{ data.description }}</p>
  </div>

  <div mat-dialog-content class="fd-modal__content" *ngIf="data.html">
    <p [innerHtml]="data.description"></p>
  </div>

  <div mat-dialog-actions class="fd-modal__actions">
    <fd-button class="fd-modal__close-button" [content]="'Confirmar'" (trigger)="handleConfirmClick()"> </fd-button>
    <fd-button
      class="fd-modal__close-button"
      fdSecondary
      [content]="data.correctionLabel ? 'Corrigir' : 'Cancelar'"
      (trigger)="handleCancelClick()"
    >
    </fd-button>
  </div>
</div>
